import { CompletenessPanel } from './CompletenessPanel';
import { QuickStatsPanel } from './QuickStatsPanel';
import type { DashboardSummary } from './types';

interface SummaryStripProps {
  completeness: DashboardSummary['completeness'];
  quickStats: DashboardSummary['quickStats'];
  loading: boolean;
  providerId?: number;
  profileSuggestionsEnabled?: boolean;
}

export const SummaryStrip = ({
  completeness,
  quickStats,
  loading,
  providerId,
  profileSuggestionsEnabled,
}: SummaryStripProps) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="bg-white rounded-xl border border-grey-900 shadow-sm p-6 min-h-40 animate-pulse" />
        <div className="bg-white rounded-xl border border-grey-900 shadow-sm p-6 min-h-40 animate-pulse" />
      </div>
    );
  }

  return (
    <div data-cy="dashboard-summary-strip" className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      {/* Key by providerId so the suggestions actor remounts cleanly when
          the viewed provider changes (impersonation, delegation, admin tools).
          @xstate/react's useActorRef returns a stable ref for the lifetime of
          the component, so the only way to force a fresh machine is a remount. */}
      <CompletenessPanel
        key={providerId ?? 'no-provider'}
        {...completeness}
        providerId={providerId}
        enabled={profileSuggestionsEnabled}
      />
      <QuickStatsPanel {...quickStats} />
    </div>
  );
};
